import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
	'https://heocxyrunuvilpdfnoib.supabase.co',
	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhlb2N4eXJ1bnV2aWxwZGZub2liIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTMwMTA2NTAsImV4cCI6MjAyODU4NjY1MH0.Q8GhwcA0LwuQdX-2HXUr9HgsXsILHWqYwcqCY6uENHU'
)
